import fetcher from 'api/fetcher';
import axios, { AxiosError, Canceler } from 'axios';
import { MagritteNotificationName } from 'utils/constants/notification';
import { INFO_LETTERS, SYSTEM_NOTIFICATIONS } from 'utils/constants/settings';

import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

let cancelPreviousRequest: Canceler | undefined;

export const saveSubscriptionSettings =
    (onError?: () => void, abortSignal?: AbortSignal): AppThunkAction<Promise<void>> =>
    (dispatch, getState) => {
        const { systemNotifications, infoLetters } = getState().settings;
        const body = {
            [SYSTEM_NOTIFICATIONS]: systemNotifications,
            [INFO_LETTERS]: infoLetters,
        };

        cancelPreviousRequest?.();
        const source = axios.CancelToken.source();
        cancelPreviousRequest = source.cancel;

        return fetcher
            .post('/api/v1/settings', body, {
                cancelToken: source.token,
                signal: abortSignal,
            })
            .then(() => {
                dispatch(addMagritteNotification(MagritteNotificationName.SubscriptionSettingsSaveSuccess));
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error) || abortSignal?.aborted) {
                    return;
                }
                onError?.();
                dispatch(addMagritteNotification(MagritteNotificationName.SubscriptionSettingsSaveError));
            });
    };
